export default {
  title: 'Download',
  author: ' Investia app',
  buttonLabel: 'Install',
  closeButtonLabel: 'Close',
};
